import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'patientName'
})
export class PatientNamePipe implements PipeTransform {
  transform(name): string {
    return PatientNamePipe.transform(name);
  }

  static transform(name): string {
    if (!name) {
      return name;
    }

    const patientName = [];
    let middleName = '';
    if (name.family) {
      patientName.push(name.family);
    }

    if (name.given) {
      patientName.push(name.given);
    }
    let pName = patientName.join(', ');

    if (name.middle) {
      middleName = name.middle;
      pName = [pName, middleName].join(' ');
    }

    return pName || name.text;
  }
}
